import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes';
import Amplify, * as AmplifyModuls from 'aws-amplify';
import { AmplifyPlugin, AmplifyEventBus } from 'aws-amplify-vue';
import aws_exports from './aws-exports';
import store from './vuex/store'
import * as VueGoogleMaps from "vue2-google-maps";
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Chartkick from "vue-chartkick";
import Chart from "chart.js";

Amplify.configure(aws_exports);
Vue.use(AmplifyPlugin, AmplifyModuls);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAlVfuJGERcHtVVko2_VQsNDPgV18eRYvE",
    libraries: "places"
  }
});

Vue.use(Chartkick.use(Chart));

const { dispatch, getters } = store

dispatch('auth/findUser');

Vue.config.productionTip = false

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  var web_user_authenticated = getters['auth/webUserAuthed']
  if (to.matched.some(record => record.meta.requiresLogin) && (!web_user_authenticated)) {
    next("/")
  } else {
    next()
  }
})

AmplifyEventBus.$on('authState', async (state) => {

  const pushPathes = {
    signedOut: () => {
      dispatch('logout')
      router.push({ path: '/account/signin' })
    },
    signIn: () => {
      // router.push({ path: '/account/signin' })
    },
    signedIn: () => {
      dispatch('auth/findUser');
      // router.push({ path: '/' })
    }
  }
  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]()
  }
})

window.EventHub = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
